import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { WithPerspectives } from '~/components/MyWorkspace/ManagePerspectives';
import { Widget } from '~/components/MyWorkspace/Widget';

import { WidgetProps } from '../../data/widgets';

import { BottomActionButtons } from './components/BottomActions';
import { Content } from './components/Content';
import { useMyTeamWidget } from './useMyTeamWidget';
import { useSxStyles } from './useStyles';

export interface MyTeamWidgetProps extends WidgetProps<WithPerspectives> {}

export const MyTeamWidget: React.FC<MyTeamWidgetProps> = ({
  title,
  config,
}) => {
  const { t } = useTranslation();
  const sxStyles = useSxStyles();

  const {
    loading,
    failedToLoad,
    teamMembers,
    activeMemberId,
    showDetailsForMember,
    handleActiveMemberChange,
    handleShowMemberDetails,
    handleCloseMemberDetails,
    bottomActionButtonsProps,
  } = useMyTeamWidget(config);

  return (
    <Widget
      title={title || t('myTeam')}
      content={
        <Content
          loading={loading}
          failedToLoad={failedToLoad}
          teamMembers={teamMembers || []}
          activeMemberId={activeMemberId}
          showDetailsForMember={showDetailsForMember}
          handleActiveMemberChange={handleActiveMemberChange}
          handleShowMemberDetails={handleShowMemberDetails}
          handleCloseMemberDetails={handleCloseMemberDetails}
        />
      }
      actions={<BottomActionButtons {...bottomActionButtonsProps} />}
      customSxStyles={{ actions: sxStyles.widgetActions }}
      dataCy="team-widget"
    />
  );
};
